/** Parse Supabase / OAuth errors returned in the URL after redirect. */
export function readAuthCallbackError(): string | null {
  const hash = window.location.hash.startsWith('#')
    ? new URLSearchParams(window.location.hash.slice(1))
    : null;
  const query = new URLSearchParams(window.location.search);

  const description =
    hash?.get('error_description') ??
    query.get('error_description') ??
    hash?.get('error') ??
    query.get('error');

  if (!description) {
    return null;
  }

  try {
    return decodeURIComponent(description.replace(/\+/g, ' '));
  } catch {
    return description;
  }
}

export function clearAuthCallbackParams(): void {
  const clean = `${window.location.origin}${window.location.pathname}`;
  window.history.replaceState({}, document.title, clean);
}
